import { ShieldCheck, FileCheck2, MapPin, BadgeCheck } from "lucide-react";
import { CONTACT } from "../data/content";
import { FadeUp } from "./Reveal";

const ITEMS = [
  { icon: BadgeCheck, label: "HIDDENBIOMES LLP", sub: "Limited Liability Partnership" },
  { icon: ShieldCheck, label: "GST Registered Business", sub: `GSTIN ${CONTACT.gstin}` },
  { icon: FileCheck2, label: "Udyam Registered", sub: "Micro Enterprise · Services" },
  { icon: MapPin, label: "Indore, Madhya Pradesh", sub: "Registered Office · India" },
];

export const Trust = () => (
  <section data-testid="trust-section" className="relative border-y border-gold/10 bg-forest-900/30">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
      <FadeUp>
        <div className="flex items-center gap-4 mb-10 justify-center">
          <span className="h-px w-10 bg-gold/40" />
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-gold">
            Travel With Confidence
          </span>
          <span className="h-px w-10 bg-gold/40" />
        </div>
      </FadeUp>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
        {ITEMS.map((it, i) => (
          <FadeUp key={it.label} delay={i * 0.08}>
            <div
              data-testid={`trust-item-${i + 1}`}
              className="flex flex-col items-center text-center gap-3"
            >
              <it.icon size={20} className="text-gold" strokeWidth={1.5} />
              <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-cream">
                {it.label}
              </span>
              <span className="font-mono text-[10px] tracking-[0.12em] text-fog">
                {it.sub}
              </span>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
